import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { ModalProps } from "types/utils/modal";

export const DiscardFilingDraft = ({
  isOpen,
  close,
  onDiscard,
}: { onDiscard: () => void } & ModalProps) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <Modal.Header>
          <Modal.Title>Discard Filing Draft?</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-text-60 t-text-body-sm">
            If you cancel now, the filing draft and all parsed data will be
            lost. Are you sure you want to proceed?
          </div>
        </Modal.Body>

        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Return to Draft</Button>
          </Modal.RawClose>
          <Button customType="danger" onClick={onDiscard}>
            Yes, Discard Draft
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
